import {Proxy} from "../../../settings";
import {potentionalClientType} from "./getPotentionalClients";
import {basePostRequest} from "../base/basePostRequest";

const postPotentionalClient = async (data: potentionalClientType) =>
  basePostRequest<potentionalClientType>(`${Proxy}/potentional_client/`, data);

export default postPotentionalClient;
